<template>
  <div class="all_box" v-if="list.length>0">
    <div class="all_title">
      {{$t('base.recommendSellers')}}
      <router-link :to="{ path: '/seller/list' }" target="_blank">{{$t('base.seeAll')}}</router-link>
    </div>
    <div class="all_box">
      <div class="swiper_box_list">
        <swiper class="swiper" :options="swiperOption">
          <swiper-slide class="recom_slide" v-for="(item, index) in list" :key="index">
            <div class="slide_box">
              <!-- <span class="favorite" @click="favorite(item)" :class="item.IsAttention ? 'on' : ''" v-if="userInfo != null"></span> -->
              <router-link :to="{path:'/seller/detail/'+item.Id}" target="_blank">
                <div class="recom_img_box">
                  <div class="recom_img_block">
                    <el-image class="recom_img" :src="item.StoreLogo!='没有可上传的图片'?item.StoreLogo+'?imageView2/2/w/200':'../static/images/noimg.svg'" fit="scale-down"></el-image>
                  </div>
                </div>
                <div class="slide_txt">
                  <p class="line_txt1">{{ item.StoreName }}</p>
                  <span>{{ item.CommoditySellCount }} {{ item.CommoditySellCount != 1 ?$t('base.itemsForSale'):$t('base.itemForSale')}}</span>
                </div>
              </router-link>
            </div>
          </swiper-slide>
        </swiper>
        <div class="list_prev list_prev_recom" slot="button-prev"></div>
        <div class="list_next list_next_recom" slot="button-next"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import { getInfo, setAttention } from "@/api/public";

export default {
  name: "recommendswiper",
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      ps: 12, //pagesize
      pi: 1, //pageindex
      userInfo: '',
      list: '',
      areaData:this.$enumInfo.AreaData,
      areaName:null,
      swiperOption: {
        slidesPerView: "auto",
        spaceBetween: 18,
        slidesPerGroup: 6,
        loopFillGroupWithBlank: true,
        navigation: {
          nextEl: ".list_next_recom",
          prevEl: ".list_prev_recom",
        },
      },
    };
  },
  created() {
    this.userInfo = getInfo();
    this.GetStoresList()
  },
  methods: {
    favorite(obj) {
      let id = obj.Id;
      obj.IsAttention = !obj.IsAttention;
      setAttention(id, 1)
    },
    GetStoresList() {
      let that = this
      let data = { 'StoreName': '', 'IsRecommend': true, 'MemberId': '', 'PageIndex': that.pi, 'PageSize': that.ps }
      if (that.userInfo != null) {
        data.MemberId = that.userInfo.MappingUserId
      }
      //console.log(data)
      this.$get(this.$interface.GetStoresList, data).then(res => {
        if (res.result != 0) {
          let result=res.data;

          // vip 卢小喷 放在第一个
          res.data.map((item,i)=>{
            if(item.Id=='373131'){
              var newdata=item;
              result.splice(i, 1);
              result.unshift(newdata)
            }
          })
          // vip 结束
          that.list = result
        }
      })
    },
  },
};

</script>
<style scoped>
.recom_slide {
  width: 184px;
  /* height: 290px; */
  height: 245px;
}

.recom_slide .slide_box {
  border-radius: 4px;
  /* border: 0.5px solid #e0e0e0;*/
  position: relative;
  margin-top: 1px;
  margin-left: 1px;
}

.recom_img_box {
  padding: 15px;
  /*border-bottom: 0.5px solid #e0e0e0;*/
  /* background: #f7f7f7; */
}
.recom_img_block,
.recom_img {
  width: 152px;
  height: 152px;
  overflow: hidden;
}

</style>



// WEBPACK FOOTER //
// src/components/swiper/seller.vue